import { useEffect, useState } from 'react';
import { Typography } from '@mui/material';
import MediaErrorSnackbar from './MediaErrorSnackbar/MediaErrorSnackbar';
import DeviceSelectionScreen from './DeviceSelectionScreen/DeviceSelectionScreen';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';
import { useAppState } from '../../state';
import IntroContainer from '../IntroContainer/IntroContainer';
import AvataraModal from '../AvataraModal/AvataraModal';
import Snackbar from '../Snackbar/Snackbar';

export default function PreJoinScreens() {
  const [mediaError, setMediaError] = useState<Error>();
  const { getAudioAndVideoTracks, isConnecting, isKnocking, isJoining, userBooted, setUserBooted } = useVideoContext();
  const { isFetching } = useAppState();

  useEffect(() => {
    getAudioAndVideoTracks().catch(error => {
      setMediaError(error);
    });
  }, [getAudioAndVideoTracks]);

  const subContent = <MediaErrorSnackbar error={mediaError} />;

  return (
    <IntroContainer subContent={subContent} displayActiveRooms={!isFetching && !isConnecting && !isJoining}>
      <DeviceSelectionScreen />
      <AvataraModal
        open={isKnocking}
        handleClose={() => console.log('closing waiting modal')}
        children={<Typography variant="h6">Waiting for the host to let you in...</Typography>}
      />
      <Snackbar
        open={userBooted}
        headline=""
        handleClose={() => setUserBooted(false)}
        message="Host left the room!"
        variant="warning"
        horizontal="center"
      />
    </IntroContainer>
  );
}
